<template>
    <v-card>
        <v-card-title>
            <v-select
                      :items="services"
                      item-title="name"
                      label="Selecione o serviço"
                      density="compact"
                      return-object
                      @update:modelValue="serviceChanged">
            </v-select>
        </v-card-title>
        <v-card-text>
            <FormService
                         :user="user"
                         v-model="modelValue.invoice"
                         @created="createdObject"
                         @updated="updatedObject" />
        </v-card-text>
    </v-card>
</template>
<script>
import FormService from '@/components/FormService.vue';
export default {
    components: {
        FormService,
    },
    data() {
        return {
            dialog: false,
            services: [
                { name: 'Mensalidade 75', amount: 75, ref: this.$moment().format('MM/YY'), desc: 'Assinatura GGrupos ' + this.$moment().format('MM/YY'), cashflow_category: { id: 1, name: 'Assinatura' }, quantity: 1 },
                { name: 'Mensalidade 99', amount: 99, ref: this.$moment().format('MM/YY'), desc: 'Assinatura GGrupos ' + this.$moment().format('MM/YY'), cashflow_category: { id: 1, name: 'Assinatura' }, quantity: 1 },
            ],
            modelValue: {
                invoice: {
                    quantity: 1,
                    cashflow_category: { id: 1 },
                    type: this.$INVOICE_TYPE_DIC.SERVICE.value
                }
            }
        }
    },
    methods: {
        createdObject() {

        },
        updatedObject() {

        },
        serviceChanged(newService) {
            const vm = this;

            vm.modelValue = {
                invoice: {
                    ref: newService.ref,
                    amount: newService.amount,
                    description: newService.desc,
                    cashflow_category: newService.cashflow_category,
                    due_date: vm.$moment(new Date()).endOf('month').format('YYYY-MM-DD'),
                    quantity: 1,
                    type: vm.$INVOICE_TYPE_DIC.SERVICE.value
                }
            };
        }
    },
    props: {
        user: Object
    }
};
</script>